const destinations = [
  {
    name: "Bahamas",
    context: "Bimini, Nassau, and the Exumas are regular destinations for Pompano Beach boaters and fishing charters. Just 50 nautical miles from the Hillsboro Inlet via the Gulf Stream. Bahamas customs requires valid passports for all visitors",
    urgency: "Fishing tournaments and diving trips book 3–7 days out — passport issues discovered at the marina are common emergencies",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Caribbean Cruises",
    context: "Port Everglades — 15 miles south — serves Royal Caribbean, Celebrity, Holland America, and Princess with itineraries to the Eastern, Western, and Southern Caribbean. Pompano Beach residents are frequent cruisers",
    urgency: "Last-minute cruise deals from Port Everglades are booked with 2–4 weeks notice — passport validity is rarely the first thing checked",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Europe",
    context: "Mediterranean cruises, Italian villa rentals, and French Riviera yacht charters attract Pompano Beach's affluent traveler base. Direct flights from FLL and MIA to major European hubs",
    urgency: "European yacht charters and villa rentals require passport copies months before travel — expiration surprises are costly",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada",
    context: "Many Pompano Beach snowbirds maintain summer properties in Ontario, Quebec, and Atlantic Canada. Cross-border travel requires valid U.S. passports for air travel",
    urgency: "Snowbirds heading north in May discover expired passports stored at their Florida winter residence",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Central & South America",
    context: "Costa Rica, Panama, Colombia, and Peru draw Pompano Beach adventure travelers and retirees. FLL offers extensive Latin American route connections",
    urgency: "Adventure travel and eco-tourism trips often confirm 3–6 weeks out — passport validity verification happens late in planning",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Transatlantic & World Cruises",
    context: "Port Everglades is a major embarkation point for world cruises, transatlantic crossings, and repositioning cruises to Europe and Asia. Seabourn, Silversea, and Regent Seven Seas depart regularly",
    urgency: "World cruise boarding documents are required 60–90 days before departure — the longest advance passport requirement in leisure travel",
    icon: "ri-map-pin-2-line",
  },
];

const stats = [
  { stat: "62%", label: "of Pompano Beach expedited requests involve cruise departures, fishing charters, or yacht travel to the Bahamas" },
  { stat: "2 Airports", label: "within 40 miles — FLL and MIA offer extensive international connections for Pompano Beach travelers" },
  { stat: "Nov–Apr", label: "peak season when snowbird population surges and cruise bookings spike from Port Everglades" },
  { stat: "3 Days", label: "shortest Bahamas fishing tournament passport emergency we have processed for a Pompano Beach angler" },
];

export default function PompanoDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Pompano Beach Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From Bahamas fishing tournaments and Port Everglades cruises to European yacht charters and Canadian summer homes, Pompano Beach's coastal lifestyle generates unique passport urgency patterns.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Florida Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Broward, Palm Beach, and Miami-Dade counties with the same expedited passport expertise.
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/cities/fort-lauderdale" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Fort Lauderdale <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/boca-raton" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Boca Raton <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/miami" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Miami <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}